<template>
  <div class="step step1" :class="{ 'step_active': active }">
    <h2 class="pform__title" ref="title">Для получения максимальной скидки, заполните,&nbsp;пожалуйста, следующие данные:</h2>
    <div class="pform__dot"></div>
    <div class="step__inner">
      <TextInput :mode="1" :required="true" @setError="errors.id = $event" v-model="form.step1.id" text="Номер ипотечного договора:" name="step1_id" :disabled="true" />
      <TextInput :mode="1" :required="true" @setError="errors.name = $event" v-model="form.step1.name" text="Страхователь:" name="step1_name" :disabled="true" />
      <SelInput :mode="2" :required="true" text="Банк кредитор:" name="step1_bank" :options="banks" v-model="form.step1.bank" />
      <TextInput v-if="customBankNameEnabled" :mode="2" :required="customBankNameEnabled" text="Укажите название банка:" name="step1_customBankName" v-model="form.step1.customBankName" />
      <div class="step1__tooltipinput">
        <label class="step1__tooltipinput-label">
          <span class="step1__tooltipinput-label-text">
            Введите сумму остатка ссудной задолженности на&nbsp;<span class="step1__tooltipinput-label-text-date">{{
              form.step1.date }}</span>
          </span>
          <div class="step1__tooltipinput-cont">
            <input class="aoformfield step1__tooltipinput-rub" placeholder="12 345 678" autocomplete="off" type="text"
              inputmode="numeric" :readonly="$store.getters.loading" name="step1_sumRoubles" v-maska:[maskRoublesSum]
              v-model="sumRub" @blur="checkSum">
            <span class="step1__tooltipinput-cont-spacer">руб.</span>
            <input class="aoformfield step1__tooltipinput-kop" placeholder="00" autocomplete="off" type="text"
              inputmode="numeric" :readonly="$store.getters.loading" name="step1_sumKopecks" v-maska data-maska="##"
              v-model="sumKop" @blur="checkSum">
            <span>коп.</span>
            <input type="hidden" name="step1_sum" :value="sum">
          </div>
        </label>
        <div class="tooltip tooltip_compressed tooltip_wide tooltip_smicon" @click.stop.prevent>
          <div class="tooltip__icon tooltiptrigger" @click.stop.prevent>
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="11" fill="#D2D4DA" />
              <path d="M12.3659 13.88H11.1659C11.1659 13.44 11.3059 12.99 11.5859 12.53C11.8759 12.07 12.1859 11.675 12.5159 11.345C12.8559 11.005 13.1659 10.62 13.4459 10.19C13.7359 9.76 13.8809 9.355 13.8809 8.975C13.8809 8.005 13.1109 7.52 11.5709 7.52C10.6709 7.52 9.77092 7.785 8.87092 8.315V7.115C9.77092 6.585 10.7359 6.32 11.7659 6.32C12.7659 6.32 13.5809 6.54 14.2109 6.98C14.8409 7.41 15.1559 8.035 15.1559 8.855C15.1559 9.245 15.0609 9.635 14.8709 10.025C14.6809 10.415 14.4459 10.77 14.1659 11.09C13.8959 11.4 13.6209 11.705 13.3409 12.005C13.0709 12.305 12.8409 12.62 12.6509 12.95C12.4609 13.27 12.3659 13.58 12.3659 13.88ZM12.3209 15.815C12.4709 15.945 12.5459 16.13 12.5459 16.37C12.5459 16.61 12.4709 16.8 12.3209 16.94C12.1709 17.07 11.9859 17.135 11.7659 17.135C11.5459 17.135 11.3559 17.07 11.1959 16.94C11.0459 16.8 10.9709 16.61 10.9709 16.37C10.9709 16.13 11.0459 15.945 11.1959 15.815C11.3559 15.685 11.5459 15.62 11.7659 15.62C11.9859 15.62 12.1709 15.685 12.3209 15.815Z" fill="white" />
            </svg>

          </div>
          <div class="tooltip__body tooltip__body-app" @click.stop.prevent>
            <div class="tooltip__icon tooltip__close tooltiptrigger">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.96875 8.96375L24.0016 23.9966" stroke="#5B5D6B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M8.96875 24.0363L24.0016 9.0034" stroke="#5B5D6B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <div class="tooltip__text">Сумму остатка задолженности Вы можете посмотреть в&nbsp;своем графике платежей к&nbsp;Кредитному договору или мобильном приложении Банка, остаток указывается на&nbsp;дату начала следующего периода страхования
            </div>
          </div>
        </div>
        <div class="step1__tooltipinput-error" v-html="errors.sum" />
      </div>
      <h3 class="step__title">Контактная информация</h3>
      <NumberInput :mode="2" placeholder="+7 (914) 000 00 00" :required="true" mask="+7 (###) ### ## ##" @setError="errors.tel = $event" :filled="(v) => v.length == 18" v-model="form.step1.tel" text="Телефон" name="step1_tel" />
      <EmailInput placeholder="@" :mode="2" :required="true" @setError="errors.email = $event" v-model="form.step1.email" text="E-mail" name="step1_email" />
      <NumberInput :mode="2" :disabled="true" v-if="form.step1.prolongPayment" class="step1__prolongPayment" @setError="errors.prolongPayment = $event" :modelValue="form.step1.prolongPayment" text="Ваша страховая премия пролонгации составляет" name="step1_prolongPayment" />
      <div class="step__buttoncont" :class="{'step__buttoncont_shifted': form.step1.prolongPayment}">
        <Btn v-if="!form.step1.prolongPayment" ref="btn0" class="step__next step__next_special2" :disabled="!filled" @click.stop.prevent="getProlongPayment">Рассчитать стоимость</Btn>
        <Btn v-else ref="btn1" class="step__next step__next_special2" tag="a" target="_blank" :href="prolongPaymentRedirect">Оплатить</Btn>
        <Btn ref="btn2" class="step__next step__next_special2 step__next_special2-sm newbtn_gray2" :disabled="!filled2" @click.stop.prevent="btnPress">Оставьте заявку и мы свяжемся&nbsp;с&nbsp;Вами</Btn>
      </div>
      <p class="step1__text">
        Если у вас есть вопросы, или вам удобнее предоставить эту информацию по&nbsp;телефону, звоните на&nbsp;нашу <a class="newred" href="tel:8-800-700-7-333">бесплатную горячую линию круглосуточно</a>:
        <strong class="nowrap"><a href="tel:8-800-700-7-333">8-800-700-7-333</a></strong>
      </p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TextInput from '../inputs/TextInput.vue';
import Btn from '../Btn.vue';
import nameSuggest from '../../mixins/nameSuggest';
import SelInput from '../inputs/SelInput.vue';
import NumberInput from '../inputs/NumberInput.vue';
import EmailInput from '../inputs/EmailInput.vue';
import { vMaska } from 'maska'

export default {
  components: { TextInput, Btn, SelInput, NumberInput, EmailInput },
  mixins: [nameSuggest],
  props: {
    active: { type: Boolean }
  },
  directives: { maska: vMaska },
  data: () => ({
    errors: {},
    sumRub: '',
    sumKop: '',
    sumErrorMessage: '',
    maskRoublesSum: {
      tokens: {
        '?': { pattern: /[0-9,]/ },
        '&': { pattern: /[1-9]/ }
      },
      mask: function (string) {
        let str = ''
        let l1 = Math.min(string.replace(/\s/g, '').length, 8)
        str = '#'.repeat(l1 % 3)
        str += ' ###'.repeat(Math.floor(l1 / 3))
        str = str.trim()
        if (str.length == 0)
          return '&'
        str = str.replace('#', '&')
        if (l1 < 8)
          return str + '#'
        return str
      },
      eager: false,
    },
    banks: ['Росбанк Дом', 'Сбербанк', 'ВТБ', 'Т-Банк', 'Газпромбанк', 'Россельхозбанк', 'Другой']
  }),
  methods: {
    async getProlongPayment() {
      const payment = await this.$store.dispatch('getprolongPayment')
      if (payment) {
        this.form.step1.prolongPayment = payment
      }
    },
    checkSum() {
      let r = this.sumRub.replace(/\s/g, '')
      let k = this.sumKop.replace(/\s/g, '')

      if ([r, k].find(el => el.match(/[^\d]/)))
        return this.errors.sum = 'Ввод должен содержать только цифры'
      if (r.length < 5)
        return this.errors.sum = 'Не менее 10 000 рублей'
      if (r.length > 8)
        return this.errors.sum = 'Не более 99 999 999,99 рублей'
      if (r[0] == '0')
        return this.errors.sum = 'Первая цифра не должна быть нулём'
      if (k.length > 2)
        return this.errors.sum = 'Не более 99 копеек'
      if (k.length == 0)
        return this.errors.sum = '* Пожалуйста, укажите точную сумму до копеек.<br> В противном случае банк может не принять полис'
      if (k.length == 1)
        return this.errors.sum = 'Укажите точную сумму копеек (2&nbsp;знака)'
      return this.errors.sum = ''
    },
    btnPress(e) {
      let target = e.target
      if (!target.classList.contains('newbtn'))
        target = target.closest('.newbtn')
      switch (target) {
        case this.$refs.btn2.$el:
          if (!this.filled2) return
          this.form.additions.btn = "2"

          return this.$store.dispatch('sendAndFinish', {
            title: 'Спасибо!<br>Мы свяжемся с&nbsp;Вами<br class="onlydesk"> в ближайшее время',
            text: false,
            button: false,
            width: '480px'
          })
        default:
          console.error('Ошибка btnPress: неизвестная кнопка')
      }
      this.form.additions.btn = target.textContent.trim()
    }
  },
  computed: {
    ...mapState(['form', 'prolongPaymentRedirect']),
    customBankNameEnabled() {
      return this.form.step1.bank.toLowerCase().trim() == 'другой'
    },
    filled() {
      const required = ['name', 'id', 'bank', 'sum']
      for (let key of required) {
        if (this.errors[key] || !this.form.step1[key]) return false
      }

      return this.filled2
    },
    filled2() {
      const required = ['tel', 'email']
      for (let key of required) {
        if (!this.errors[key] && this.form.step1[key])
          return true
      }
      return false
    },
    sum() {
      return this.sumRub + ',' + this.sumKop
    }
  },
  watch: {
    sum(v, old) {
      if (v != old) {
        this.checkSum()
        this.form.step1.sum = v
      }
    }
  }
}
</script>

<style lang="sass">
.heroslide_h594
  @include since(991.02px)
    min-height: 570px
    .heroslide__wrapper
      height: 570px
.step1
  & &__prolongPayment:nth-child(n)
    border: 1px solid colors.$newgray
    border-radius: 8px
    --inputfs: 20px
    --inputfw: 500
    --inputpt: 10px
    --inputpx: 19px
    --inputpb: 6px
    margin-top: 72px
    margin-bottom: 0px
  &__tooltipinput
    z-index: 3
    @include since(768px)
      margin-top: 45px
      margin-bottom: 7px !important    
    position: relative
    padding-right: 30px
    &-error
      font-size: 14px
      font-weight: 500
      color: colors.$newred
      margin-top: 10px
    &-label
      &-text
        display: block
        line-height: 1.1
        font-size: 14px
        margin-bottom: 5px
        @include for-mob 
          marbin-bottom: 0px
          font-size: 12px
        &-date
          color: black
          font-weight:500
    /*
      @include since(768px)
        &
          margin-top: 45px
          margin-bottom: 7px !important
    .tooltip
      position: absolute
      right: 0px
      top: 50% !important
      transform: translateY(-50%) !important
      margin: 0
      &, .tooltip__icon svg
        width: 24px
        height: 24px
      @include for-mob
        right: 10px
        top: 35% !important
        &, .tooltip__icon svg
          width: 20px
          height: 20px
    &-kop.aoformfield
      width: 30px   
      text-align: center
      font-weight: 500
    &-rub.aoformfield
      text-align: center
      width: 96px
      font-weight: 500
    &-cont
      display: flex
      align-items: center
      &-spacer
        margin-right: 15px          
  &__text
    margin-top: 25px
    font-size: 16px
    line-height: 1.28
    color: colors.$gray5
    @include for-mob
      font-size: 12px
      margin-top: 45px
.step 
  width: 100%
  &__addressline
    display: flex
    align-items: flex-end
    margin-bottom: 32px
    &-main
      flex-grow: 1  
      height: 100%
      margin-bottom: 0
    &-flat
      height: 100%  
      margin-left: 32px
      width: 50px
      margin-bottom: 0
      .aoformlabel__error:nth-child(n) ~ .aoformfield
        border-bottom: 1px solid colors.$newred
        box-shadow: 0px 2px 0px -1px colors.$newred
      .aoformlabel__error
        display: none !important



  &__buttoncont
    margin-top: 40px
    &_shifted
      margin-top: 20px
  & &__buttonflex
    display: flex
    align-items: center
    justify-content: center
    margin: 32px 0
    >*:not(:last-child)
      margin-right: 16px
  & &__delbutton
    margin-bottom: 0
    margin-left: auto
  &:not(&_active)
    opacity: 0 !important
    max-height: 200px  
    overflow: hidden
  &__inner
    width: 604px
    max-width: 100%
    margin: 0 auto
  &__contract
    position: relative
    &-close
      flex-shrink: 0
      position: absolute
      top: 2px
      right: 2px
      z-index: 5
      width: 20px
      height: 20px
      cursor: pointer
      color: black
      svg
        width: 100%
        display: block

  &__title
    font-weight: 400
    font-size: 20px
    line-height: 1.18
    padding-bottom: 8px
    text-align: center
    margin-bottom: 26px
    color: colors.$gray3
    text-align: left
    border-bottom: 1px solid colors.$moar_silver_for_the_god_of_silver
    &:not(:first-child)
      margin-top: 40px
    &_special
      position: relative
      padding-left: 30px
      padding-right: 30px
    &_left
      text-align: left
    &_smspace
      margin-bottom: 8px
    &_incspace
      margin-bottom: 64px
    &_topmg
      margin-top: 60px
  &__minititle
    font-size: 20px
    line-height: 1.18
    font-weight: 400
    color: colors.$gray3
    margin-bottom: 16px
  &__microtitle
    font-size: 16px
    font-weight: 400
    line-height: 1.28
    margin-bottom: 40px
  &__subtitle
    font-size: 14px
    line-height: 1.12
    color: colors.$newgray
    margin-bottom: 40px
    text-align: center
  &__text
    font-size: 16px
    line-height: 1.28
    color: colors.$gray5
    margin-bottom: 8px
  &__sm
    font-size: 14px
  &__line
    border-bottom: 1px solid colors.$moar_silver_for_the_god_of_silver
    width: 100%
    margin: 40px 0 64px
    &_divider
      margin-bottom: 40px
  &__next
    width: 328px
    max-width: 100%
    margin: 32px auto
    &_special:nth-child(n)
      margin: 0
      min-width: 210px
    &_special2:nth-child(n)
      width: 100%
      margin: 13px auto 50px
      @include for-mob
        font-size: 20px
        padding: 10px
        min-height: 68px
        margin: 13px auto 16px
      &:last-child
        margin-bottom: 0
    &_special2-sm:nth-child(n)
      @include for-mob
        font-size: 15px
    &_special-formlink:nth-child(n)
      font-size: 14px
  @include for-mob
    &__title
      font-size: 15px
      line-height: 1.16
      margin-bottom: 5px
      border: none
      &:not(:first-child)
        margin-top: 32px
      &_smspace
        margin-bottom: 8px
      &_special
        font-size: 18px
        text-align: left
        padding-left: 0
        padding-right: 0
        display: flex
        align-items: center
    &__subtitle
      margin-bottom: 32px
    &__text
      line-height: 1.12
    &__minititle_spaced
      padding: 32px 0 16px
    &__minititle_spaced-bottom
      padding: 0 0 16px
    &__contract
      &-close
        margin-left: auto
        padding-left: 10px
        width: 30px
        position: static
  & &__buttonflex >*:not(:last-child)
    margin-right: 10px
  &__next_special:nth-child(n)
    width: auto
    flex-basis: 150px
    flex-grow: 1
    min-width: 140px
    max-width: 250px
    padding-left: 10px
    padding-right: 10px

.tooltip__body.tooltip__body-app
  width: 520px
  padding: 68px 32px 56px
  .tooltip__close
    top: 16px
    right: 36px
    &, svg 
      width: 32px
      height: 32px
  .tooltip__text
    text-align: center
    font-size: 20px
    line-height: 1
    color: #808082
  @include for-mob
    width: 320px
    padding: 48px 20px 30px
    .tooltip__close
      top: 10px 
      right: 10px
      &, svg
        width: 24px
        height: 24px
    .tooltip__text
      font-size: 16px
</style>